module.exports = __webpack_public_path__ + "static/logo-4cf6ddc99325991170c89aed90c2ee97.png";